import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-host Inter + JetBrains Mono + Newsreader via @fontsource-variable
// (single woff2 per family covers all weights). Imported BEFORE tokens.css
// so the @font-face declarations are registered before the font-family
// tokens are read.
//
// Per design/UI : UX v1.0/for-engineering-fonts-updated/
// for-engineering-system/FONTS.md (EU/GDPR posture — no Google CDN calls
// in production).
//
// Newsreader is CONSUMER ONLY — it's the warm/editorial brand voice used
// for ~10 headline slots (Dashboard welcome, Coach empty hero, Onboarding
// step titles, Coaching Contract title, Coach response section headings,
// etc.). Admin SPA is intentionally all-sans (dense tool, "precise/product"
// voice) and does NOT import Newsreader. Per FONTS.md §"Where each font
// applies", that admin/consumer contrast is deliberate.
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import '@fontsource-variable/newsreader';

import '@gc-coach/design-system/tokens.css';
import './styles/global.css';

import { App } from './App.js';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
